export enum Severities {
  no_failure = "no_failure",
  confirmed_failure = "confirmed_failure",
  sensor_issue = "sensor_issue",
  reason_unknown = "reason_unknown",
}
